// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-card {
  margin: 0rem 0rem;
}

.jobtimeline thead > tr > th:first-child {
  position: sticky !important;
  left: 0;
}

.jobtimeline thead > tr > th:nth-child(2) {
  position: sticky !important;
  width: 120px;
  left: 120px;
}

.jobtimeline tbody > tr > td:first-child {
  position: sticky !important;
  left: 0;
  background: #ffffff;
}

.jobtimeline tbody > tr > td:nth-child(2) {
  position: sticky !important;
  width: 120px;
  left: 120px;
  background: #ffffff;
}

.withdrawn {
  background-color: #aa00ff;
  border: #aa00ff;
}

.nav-pills .nav-link.active {
  background-color: #0a56ae;
  color: #fefefe;
  font-weight: 500;
}

.nav-pills .nav-link {
  background-color: #fefefe;
  color: #000000;
}

.main-border-style {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}

.billrate-container {
  display: flex;
  align-items: top;
  justify-content: space-between;
}

.billrate-container:hover > .billrate-button {
  visibility: visible;
}

.billrate-button {
  visibility: hidden;
  border-radius: 0;
  color: #000000;
  background-color: #e7eef7;
  height: 100%;
  border-radius: 8px;
}

.billrate-button:hover {
  background-color: #e7eef7;
}

.billrate-inner {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.billrate-amt {
  font-size: 12px;
  white-space: nowrap;
}

@media (min-width: 1024px) {
  .station-title {
    font-size: 10px;
  }

  .substation-title {
    font-weight: 500;
    font-size: 12px;
  }

  .main-table-header-text {
    font-size: 12px;
    vertical-align: top;
  }
}
.selected-candidate-bottom,
.selected-candidate-prev {
  border-bottom: 1px solid #0a56ae !important;
}

.selected-candidate-top {
  border-top: 1px solid #0a56ae !important;
}

.selected-candidate-bottom,
.selected-candidate-top {
  border-left: 1px solid #0a56ae;
  border-right: 1px solid #0a56ae;
}

.mapping-cnd-button {
  height: 35px;
  width: 35px;
  border-radius: 10px;
  background: #8f20a9;
  background: linear-gradient(90deg, #8f20a9 0%, #4444b3 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mapping-cnd-button-inner {
  height: 20px;
  width: 20px;
  border-radius: 6px;
  border-color: #fff;
  border-style: solid;
  border-width: 2px;
  background-color: transparent;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapping-cnd-button:hover {
  transition: 0.6s;
  background: #8f20a9;
  background: #7a238f;
  background: linear-gradient(90deg, #7a238f 0%, #404095 100%);
}

.rejected-pov-icon {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #de9918;
  color: #fff;
  border-radius: 100%;
  padding: 10px;
  font-size: 11px;
  cursor: pointer;
}

.rejected-pov-icon:hover {
  background-color: #de9918;
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobOverview/JobOverview.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,2BAAA;EACA,OAAA;AACF;;AAEA;EACE,2BAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,2BAAA;EACA,OAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AACA;EACE,yBAAA;EACA,cAAA;AAEF;;AACA;EACE,mBAAA;EACA,iBAAA;EACA,uBAAA;AAEF;;AACA;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;;EACA;IACE,gBAAA;IACA,eAAA;EAEF;;EACA;IACE,eAAA;IACA,mBAAA;EAEF;AACF;AACA;;EAEE,2CAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;;EAEE,8BAAA;EACA,+BAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,4DAAA;EAKA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4DAAA;AAHF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAPF;;AAUA;EACE,yBAAA;AAPF","sourcesContent":[".table-card {\n  margin: 0rem 0rem;\n}\n\n.jobtimeline thead > tr > th:first-child {\n  position: sticky !important;\n  left: 0;\n}\n\n.jobtimeline thead > tr > th:nth-child(2) {\n  position: sticky !important;\n  width: 120px;\n  left: 120px;\n}\n\n.jobtimeline tbody > tr > td:first-child {\n  position: sticky !important;\n  left: 0;\n  background: #ffffff;\n}\n\n.jobtimeline tbody > tr > td:nth-child(2) {\n  position: sticky !important;\n  width: 120px;\n  left: 120px;\n  background: #ffffff;\n}\n\n.withdrawn {\n  background-color: #aa00ff;\n  border: #aa00ff;\n}\n\n.nav-pills .nav-link.active {\n  background-color: #0a56ae;\n  color: #fefefe;\n  font-weight: 500;\n}\n.nav-pills .nav-link {\n  background-color: #fefefe;\n  color: #000000;\n}\n\n.main-border-style {\n  border-style: solid;\n  border-width: 1px;\n  border-color: lightgray;\n}\n\n.billrate-container {\n  display: flex;\n  align-items: top;\n  justify-content: space-between;\n}\n\n.billrate-container:hover > .billrate-button {\n  visibility: visible;\n}\n\n.billrate-button {\n  visibility: hidden;\n  border-radius: 0;\n  color: #000000;\n  background-color: #e7eef7;\n  height: 100%;\n  border-radius: 8px;\n}\n\n.billrate-button:hover {\n  background-color: #e7eef7;\n}\n\n.billrate-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.billrate-amt {\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n@media (min-width: 1024px) {\n  .station-title {\n    font-size: 10px;\n  }\n\n  .substation-title {\n    font-weight: 500;\n    font-size: 12px;\n  }\n\n  .main-table-header-text {\n    font-size: 12px;\n    vertical-align: top;\n  }\n}\n\n.selected-candidate-bottom,\n.selected-candidate-prev {\n  border-bottom: 1px solid #0a56ae !important;\n}\n\n.selected-candidate-top {\n  border-top: 1px solid #0a56ae !important;\n}\n\n.selected-candidate-bottom,\n.selected-candidate-top {\n  border-left: 1px solid #0a56ae;\n  border-right: 1px solid #0a56ae;\n}\n\n.mapping-cnd-button {\n  height: 35px;\n  width: 35px;\n  border-radius: 10px;\n  background: rgb(143, 32, 169);\n  background: linear-gradient(\n    90deg,\n    rgba(143, 32, 169, 1) 0%,\n    rgba(68, 68, 179, 1) 100%\n  );\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.mapping-cnd-button-inner {\n  height: 20px;\n  width: 20px;\n  border-radius: 6px;\n  border-color: #fff;\n  border-style: solid;\n  border-width: 2px;\n  background-color: transparent;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mapping-cnd-button:hover {\n  transition: 0.6s;\n  background: rgb(143, 32, 169);\n  background: rgb(122, 35, 143);\n  background: linear-gradient(\n    90deg,\n    rgba(122, 35, 143, 1) 0%,\n    rgba(64, 64, 149, 1) 100%\n  );\n}\n\n.rejected-pov-icon {\n  width: 15px;\n  height: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #de9918;\n  color: #fff;\n  border-radius: 100%;\n  padding: 10px;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.rejected-pov-icon:hover {\n  background-color: #de9918;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
